// ScrollTarget
import React from 'react';
import ReactDom from 'react-dom';
import ScrollIntoViewIfNeeded from 'scroll-into-view-if-needed';

export default class ScrollTarget extends React.Component {

  constructor() {
    super();
    this.state = { prevNumElements: 0 };
  }

  scrollIntoViewer() {
    ScrollIntoViewIfNeeded(
      ReactDom.findDOMNode(this),
      true,
      { duration: 1000, ease: 'ease' }
    );
  }

  componentDidMount() {
    this.scrollIntoViewer();
    this.setState({ prevNumElements: this.props.numElements });
  }

  componentWillUpdate() {
    if (this.props.numElements !== this.state.prevNumElements) {
      const rect = ReactDom.findDOMNode(this).getClientRects();

      if (
        !this.props.parentHeight ||
        rect[0].top - this.props.parentHeight <= 100
      ){
        this.scrollIntoViewer();
      }

      this.setState({ prevNumElements: this.props.numElements });
    }
  }

  render() {
    return ( <div className='clear'></div> );
  }
};



// WEBPACK FOOTER //
// ./src/components/ScrollTarget.jsx